import { getIn18Text } from 'api';
export const overLimitLabel = {
    free: getIn18Text('DANGQIANWENJIANYI11'),
    ultimate: getIn18Text('DANGQIANWENJIANYI12'),
    education: getIn18Text('DANGQIANWENJIANYI13'),
    sirius: getIn18Text('DANGQIANWENJIANYI'),
};
export const totalOverLimitLabel = {
    free: getIn18Text('MIANFEIBANYUNFU'),
    ultimate: getIn18Text('QIJIANBANYUNFU'),
    education: getIn18Text('XIAOYUANBANYUNFU'),
    sirius: getIn18Text('ZUNXIANGBANYUNFU'),
};
